import styled from 'styled-components';

export const DisplayContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 50px;
  min-height: 100vh;
  .welcome-text {
    text-align: left;
    font-size: 18px;
    color: #a4a4a4;
    border-bottom: 1px solid rgba(112, 112, 112, 0.32);
    font-weight: bold;
    padding: 10px 50px;
    background-color: white;
    span {
      font-size: 25px;
      color: #545454;
    }
  }
  .tables {
    padding-left: 50px;
    padding-right: 50px;
  }
`;
